import { filters } from '../../cra/src/components/drive/content/tabs/templatesTab/resumesDictionary';

export default (activeData) => {
  if (activeData.length) {
    return activeData.filter((item) =>
      item.filterType.includes(filters.SINGLE_COLUMN),
    );
  }
  return activeData;
};
